import React from 'react';
import { CheckIcon, GiftIcon } from 'lucide-react';
import { Section } from './Section';
import { CtaButton } from './CtaButton';
import { TrustRow } from './TrustRow';
import { CHECKOUT_URL } from '../config/launch';
const included = ['Volume 1 — The System: The 8 Seconds After They Tell You ★', 'Volume 2 — Lower Body', 'Volume 3 — Spine', 'Volume 4 — Upper Body', 'Volume 5 — Special Populations & the Inversion Decision Matrix', 'Volume 6 — The Professional Shield'];
const bonusLines = ['Bonus 1 — The 10-Minute Pre-Class Calm Protocol', 'Bonus 2 — The Neutral Language Upgrade Kit', 'Bonus 3 — The 90-Second PDF Retrieval Setup', 'Bonus 4 — The Studio Interview Scenario Builder', 'Bonus 5 — The Post-Class Trust Note Vault'];
const badges = ['Save $70', 'One-time payment', 'Lifetime access'];
const anchors = [{
  label: 'A 200-hour training (typical U.S. range)',
  value: '$2,000–3,000'
}, {
  label: 'A continuing-education weekend',
  value: '$300–600'
}, {
  label: 'Liability insurance (Insureon average)',
  value: '$42/month'
}, {
  label: 'This system',
  value: '$27'
}];
export function Pricing() {
  return <Section id="pricing" background="white" labelledBy="pricing-heading" data-id="element-216" data-mp="4v8ishdbw3cs">
      <h2 id="pricing-heading" className="text-center font-serif text-[27px] font-semibold leading-[1.15] text-ink sm:text-3xl lg:text-[44px]" data-id="element-217" data-mp="9sryllpoco6u">
        Get the complete system today
      </h2>

      <div className="mx-auto mt-12 max-w-[640px] overflow-hidden rounded-2xl border border-sage/15 border-t-4 border-t-sage bg-white shadow-lift" data-id="element-218" data-mp="3d6uqko3y8i4s">
        <div className="p-6 sm:p-10" data-id="element-219" data-mp="3n6vaoc9n72a1">
          <h3 className="font-serif text-[25px] font-semibold leading-tight text-ink sm:text-3xl" data-id="element-220" data-mp="3n5u1yeg3mrvh">
            Screen &amp; Adapt™ — Yoga Edition · Complete Set
          </h3>
          <p className="mt-3 font-sans text-[15px] leading-[1.6] text-ink-soft" data-id="element-221" data-mp="2uhoehjxnuory">
            Everything you need to answer well, stay in your lane, and know when to refer.
          </p>

          <ul className="mt-8 space-y-3" data-id="element-222" data-mp="2rg37sd7augs7">
            {included.map(item => <li key={item} className="flex items-start gap-3" data-id="element-223" data-mp="2mibd5bf9sgkb">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-sage" strokeWidth={2.25} aria-hidden="true" data-id="element-224" data-mp="2mfxkf982bgfx" />
                <span className="font-sans text-[15px] leading-snug text-ink" data-id="element-225" data-mp="2w8d0u23pnwyp">{item}</span>
              </li>)}
          </ul>

          <ul className="mt-6 space-y-3 rounded-xl bg-sage-soft p-5" data-id="element-226" data-mp="23j5re82pxmyo">
            {bonusLines.map(item => <li key={item} className="flex items-start gap-3" data-id="element-227" data-mp="2igputajyva2q">
                <GiftIcon className="mt-0.5 h-4 w-4 shrink-0 text-sage" strokeWidth={1.75} aria-hidden="true" data-id="element-228" data-mp="2idtw3k0aohd8" />
                <span className="font-sans text-[15px] leading-snug text-ink-soft" data-id="element-229" data-mp="3ttikmft75og5">{item}</span>
              </li>)}
          </ul>

          <div className="mt-9 text-center" data-id="element-230" data-mp="9udy4r1spjr">
            <p className="font-sans text-[14px] text-ink-soft" data-id="element-231" data-mp="8ssd6ceokns">
              Total value: <span className="line-through" data-id="element-232" data-mp="5ahzwc0f6g74">$176</span>
            </p>
            <p className="mt-1 font-sans text-[14px] text-ink-soft" data-id="element-233" data-mp="3nfd0ot8bwv7y">
              Regular price: <span className="line-through" data-id="element-234" data-mp="3rgos94arjqis">$97 USD</span>
            </p>
            <p className="mt-3 font-serif text-[56px] font-semibold leading-none text-ink sm:text-6xl lg:text-7xl" data-id="element-235" data-mp="3rirerecpj1ir">
              $27
              <span className="ml-2 align-middle font-sans text-base font-semibold text-ink-muted" data-id="element-236" data-mp="nzoogfnwa20u">
                USD
              </span>
            </p>

            <ul className="mt-6 flex flex-wrap justify-center gap-2" data-id="element-237" data-mp="a8b8tct3xob3">
              {badges.map(badge => <li key={badge} className="rounded-full bg-sage-soft px-3.5 py-1.5 font-sans text-[12px] font-semibold text-sage" data-id="element-238" data-mp="e8249ttkwsly">
                  {badge}
                </li>)}
            </ul>

            <div className="mt-8 flex flex-col items-center" data-id="element-239" data-mp="3f8bjimm4vhvm">
              <p className="mb-3 font-sans text-[12px] text-ink-muted" data-id="element-240" data-mp="3a8p4q8qnptkp">
                You will be charged in your local currency.
              </p>
              <CtaButton href={CHECKOUT_URL} size="xl" className="w-full sm:w-auto" data-id="element-241" data-mp="359umb7wlq714">
                Yes, I want Screen &amp; Adapt™
              </CtaButton>
              <TrustRow className="mt-4 justify-center" data-id="element-242" data-mp="1t5ezjp72tae" />
            </div>
          </div>
        </div>
      </div>

      <ul className="mx-auto mt-10 grid max-w-4xl grid-cols-2 gap-3 lg:grid-cols-4" data-id="element-243" data-mp="3szyfelc5yodv">
        {anchors.map(anchor => <li key={anchor.label} className="rounded-xl bg-paper px-4 py-4 text-center" data-id="element-244" data-mp="3o6nipd12fnzo">
            <p className="font-sans text-[12px] leading-snug text-ink-soft" data-id="element-245" data-mp="3k5tusjnmi96s">{anchor.label}</p>
            <p className="mt-1.5 font-sans text-[15px] font-semibold text-ink" data-id="element-246" data-mp="kjwyhe2wc02i">{anchor.value}</p>
          </li>)}
      </ul>
    </Section>;
}